import React, { useEffect } from 'react';
import { GlobalEnvironment } from '../../../@Global/GlobalEnvironment';
import { observer } from 'mobx-react';
import { IntercomProvider } from 'react-use-intercom';
import { IntercomDetails } from './IntercomDetails';
import { boot } from '@intercom/messenger-js-sdk';

export interface IntercomManagerProps
{

}

export const IntercomManager: React.FC<IntercomManagerProps> = observer(
    () =>
    {
        const workspaceId = GlobalEnvironment.INTERCOM_WORKSPACE_ID;

        useEffect(
            () =>
            {
                const timer = setTimeout(
                    () =>
                        {
                            boot({
                                app_id: workspaceId
                            });
                        }, 10000
                );
                return () => clearTimeout(timer);
            },
            [
                workspaceId
            ]
        );

        return <IntercomProvider
            appId={workspaceId}
            autoBoot={false}
        >
            <IntercomDetails />
        </IntercomProvider>
    }
)